import axios from '../../Axios'
import React, { useContext, useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition'
import Loader from '../Loader'
import './Searchresults.css'
import Pagination from "react-js-pagination"
import Rating from 'react-rating'
import classes from '../Freightrates1/BenchmarkMasterView/LSP/lsp.module.css'
import { getImageSrc, imageFallBack } from '../../Utility'
import { AxiosRequest, getRequestData, validateInputs } from '../DiscoverNow/Utitlity'
import Modal from '../Shared/PopupModal/PopupModal'
import Compare from '../TransportComparison/Layout'
import { Urls } from '../../Urls'
import CardLoader from './Card-Loader/CardLoader'
import { Activity, currentRequestTimeStamp, encryptor, isMobile, search_suggestion } from '../../Constants'
import ReactGA from 'react-ga'
import { toast } from 'react-toastify'
import ProfileModal from '../TransporterClientScreen/ProfileModal/ProfileModal'
import { UserApiContext } from '../UserDetailsContext/UserDetailsContext'

const Searchresults = (props) => {
    const history = useHistory()
    const location = useLocation()
    const [audio_input, setaudio_input] = useState(false)
    const [submitText, setsubmitText] = useState("")
    const [data, setdata] = useState([])
    const { transcript, resetTranscript } = useSpeechRecognition()
    const [show, setshow] = useState(false)
    const [activePage, setactivePage] = useState(1)
    const [offset, setoffset] = useState(0)
    const [perpage, setperpage] = useState(5)
    const [pageCount, setpageCount] = useState(0)
    const [originalData, setoriginalData] = useState([])
    const [bigData, setbigData] = useState([])
    const [filterdata, setfilterdata] = useState([])
    // const [Filters, setFilters] = useState([])
    const [origin_filter, setorigin_filter] = useState([])
    // const [destination_filter, setdestination_filter] = useState([])
    const [module_filter, setmodule_filter] = useState([{ value: "", selected: false }])
    const [transporterData, settransporterData] = useState([])
    const [transporterCount, settransporterCount] = useState(0)
    const [loading, setloading] = useState(false)
    const [uniqueModules, setuniqueModules] = useState([])
    const [trueresults, settrueresults] = useState(false)
    const { userDetails } = useContext(UserApiContext)
    useEffect(() => {
        ReactGA.pageview('SearchResults');
        if (location.state) {
            getDiscovernowData(location.state.data)
            setbigData(location.state.data)
            var temp = location.state.data
            // var filters = []
            var modules = []
            var origins = []
            var destinations = []
            temp.map(item => {
                if (item.module_name) {
                    modules.push(item.module_name)
                }
                if (item.origin) {
                    origins.push(item.origin)
                }
                if (item.destination) {
                    destinations.push(item.destination)
                }
            })

            var unique_modules = [...new Set(modules)]
            var final_modules = []
            unique_modules.map(item => {
                final_modules.push({ "value": item, "selected": false })
            })
            setmodule_filter(final_modules)
            setuniqueModules(unique_modules)

            var unique_origins = [...new Set(origins)]
            var final_origins = []
            unique_origins.map(item => {
                final_origins.push({ "value": item, "selected": false })
            })
            // setorigin_filter(final_origins)

            var unique_destinations = [...new Set(destinations)]
            var final_destinations = []
            unique_destinations.map(item => {
                final_destinations.push({ "value": item, "selected": false })
            })
            final_destinations.map(item => {
                final_origins.push(item)
            })
            var unique_final_origin = [...new Set(final_origins)]
            setorigin_filter(unique_final_origin)
            // setdestination_filter(final_destinations)

            setoriginalData(location.state.data)
            if (unique_modules.includes("Transporter Profile") && !unique_modules.includes("Compare Now")) {
                const data1 = location.state.data
                // console.log(data1)
                const top10 = data1.slice(0, 10)
                settransporterData(top10)


                // settransporterCount(top10.length)
                // const slice = data1.slice(0,1)

                const slice = data1.slice(0, 10 + perpage)
                // console.log(slice)
                if (slice.length === 0) {
                    setdata(top10)
                }
                else {
                    setdata(slice)
                }
                // setdata(slice)
                setoffset(10)
                // console.log(data1.length - 10)
                setpageCount(Math.ceil((data1.length - 10) / perpage))
            }
            else {
                const data1 = location.state.data
                // console.log(data1)
                // const top10 = data1.slice(0,10)
                // settransporterData(top10)
                // const slice = data1.slice(0,1)
                const slice = data1.slice(offset, offset + perpage)
                // console.log(slice)
                setdata(slice)
                setpageCount(Math.ceil(data1.length / perpage))
            }
            // const data1 = location.state.data
            // // console.log(data1)
            // // const slice = data1.slice(0,1)
            // const slice = data1.slice(offset, offset + perpage)
            // // console.log(slice)
            // setdata(slice)
            // setpageCount(Math.ceil(data1.length / perpage))
            // setdata(location.state.data)
            setsubmitText(location.state.searchquery)

        }

    }, [location.state])

    const getDiscovernowData = (data) => {
        // var searchData = data[0]
        if (data && data.length > 0) {
            var new_data = {
                "lat": parseFloat(data[0].origin_lat ? data[0].origin_lat : 0),
                "lon": parseFloat(data[0].origin_lon ? data[0].origin_lon : 0),
                "location": data[0].origin ? data[0].origin : "",
                "district": data[0].origin_district ? data[0].origin_district : "",
                "state": data[0].origin_state ? data[0].origin_state : "",
                "origin": {
                    "location_name": `${data[0].origin} , ${data[0].origin_district}, ${data[0].origin_state}`,
                    "location": {
                        lon: parseFloat(data[0].origin_lon ? data[0].origin_lon : 0),
                        lat: parseFloat(data[0].origin_lat ? data[0].origin_lat : 0),
                        'label': `${data[0].origin} , ${data[0].origin_district}, ${data[0].origin_state}`
                    }
                },
                "inputOrigin": `${data[0].origin} , ${data[0].origin_district}, ${data[0].origin_state}`,
                "destination": {
                    "location_name": `${data[0].destination}, ${data[0].destination_district}, ${data[0].destination_state}`,
                    "location": {
                        lon: parseFloat(data[0].destination_lon ? data[0].destination_lon : 0),
                        lat: parseFloat(data[0].destination_lat ? data[0].destination_lat : 0),
                        'label': `${data[0].destination}, ${data[0].destination_district}, ${data[0].destination_state}`
                    }
                },

                "inputDestination": `${data[0].destination}, ${data[0].destination_district}, ${data[0].destination_state}`,
                "truck_type": data[0].truck_name,
                "destination_name": data[0].destination,
                "destination_district": data[0].destination_district,
                "destination_lat": data[0].destination_lat,
                "destination_lon": data[0].destination_lon,
                "destination_score": data[0].destination_score,
                "destination_state": data[0].destination_state,

                "origin_name": data[0].origin,
                "origin_district": data[0].origin_district,
                "origin_lat": data[0].origin_lat,
                "origin_lon": data[0].origin_lon,
                "origin_score": data[0].origin_score,
                "origin_state": data[0].origin_state,
                "filter_discovernow": [{
                    "count": 2,
                    "filter": "truck_type",
                    "filter_label": "Truck Type",
                    "isChecked": false,
                    "label": data[0].truck_name,
                    "type": data[0].truck_name,
                    "value": data[0].truck_name
                }]


            }

            if (data[0].module_name === "DiscoverNow") {
                getResults(new_data.origin, new_data.inputOrigin, new_data.destination, new_data.inputDestination, new_data.filter_discovernow[0].type ? new_data.filter_discovernow : []);

            }
            else if (data[0].module_name === "Location Dashboard") {
                getAnalysisData(new_data, 'History')
            }
        }
    }

    const getAnalysisData = (value, requestedFrom) => {
        let payloadData = value
        payloadData.status = 'requested'
        payloadData.unique_id = `${value.location}_${value.state}`

        let requestbody = { location_details: [payloadData] }
        // Activity([{ "screen": "Location Dashboard", "module": "Location Dashboard", "user_activity": { ...requestbody, 'requested_using': requestedFrom }, "timestamp": currentRequestTimeStamp() }])
        // if (requestedFrom === 'Plant' || requestedFrom === 'Search') {
        //     let uniqueKey = (`${value.location}_${value.state}`).toLowerCase()
        //     if (historyLocations.filter(item => item.unique_id.toLowerCase() === uniqueKey).length === 0 && allowedLocations === 0) {
        //         document.getElementById("GetMoreCredits").click()
        //     }
        //     else {

        //         searchData(requestbody, payloadData, true)
        //     }
        // }
        // else {
        searchData(requestbody, payloadData, false)
        // }
    }

    const searchData = (requestbody, location, shouldUpdate) => {
        // setShow(true)
        setloading(true)
        axios.post(Urls.locationapi2, requestbody)
            .then(res => {
                // console.log(res.data)
                settransporterData(res.data.location_analysis.location_details[0].analysis_data.transporter_list)
                settransporterCount(res.data.location_analysis.location_details[0].analysis_data.transporters_count)
                // setanalysisdata({})
                // setCurrentSearchedLocation('')
                // // fetchLatestData()
                // if (res.data && res.data.location_analysis && res.data.location_analysis.hasOwnProperty('allowed_locations')) {
                //     setAllowedLocations(res.data.location_analysis.allowed_locations)
                // }

                // if (res.data.location_analysis && res.data.location_analysis.location_details && res.data.location_analysis.location_details.length > 0) {
                //     if (res.data.location_analysis.location_details[0]) {
                //         let templocation = res.data.location_analysis.location_details[0]
                //         setCurrentSearchedLocation(Uppercase(`${templocation.location}, ${templocation.state}`))

                //     }
                //     if (res.data.location_analysis.location_details[0]['analysis_data']) {
                //         setanalysisdata(res.data.location_analysis.location_details[0]['analysis_data'])

                //         // Update the history if location searched is selected from autocomplete
                //         if (shouldUpdate) {
                //             updateHistory(location, historyLocations)
                //         }
                //     }
                //     else {
                //         document.getElementById("GetMoreCredits").click()
                //     }
                // }
                // setShow(false)
                setloading(false)

            })
            .catch(err => {
                // setShow(false)
                setloading(false)

            })
    }

    const getResults = (origin, inputOrigin, destination, inputDestination, filters) => {
        // console.log(filters)
        /* Code for validating and serching lanes for origin and destination given */
        if (validateInputs(origin, inputOrigin, destination, inputDestination
            // ,
            //  transitTime
        )) {
            if (filters.length > 0) {
                let request_data = getRequestData(origin,
                    inputOrigin,
                    destination,
                    inputDestination,
                    filters,
                    // [],
                    // "",
                    // transitTime,
                    // preferredTruck
                )


                // let searched_data = {
                //     origin: inputOrigin,
                //     destination: inputDestination
                // }

                getTransportersList(request_data);

            }
            else {
                let request_data = getRequestData(origin,
                    inputOrigin,
                    destination,
                    inputDestination,
                    [],
                    0,
                    // transitTime,
                    // preferredTruck
                )

                // let searched_data = {
                //     origin: inputOrigin,
                //     destination: inputDestination
                // }

                getTransportersList(request_data);

            }



        }

    }

    const getTransportersList = (request_data, resetFilters) => {
        setloading(true)
        AxiosRequest(request_data)
            .then(res => {
                // setShow(false);
                if (res.data.client_status_error) {
                    // console.log(res.data.client_status_error)
                    // toast.error('You do not have enough credits to discover more transporters!')
                    // settransporterData([])
                    // setTotalCount([])
                    // setResponseData([])
                    // setAvailableFilters([]);
                }
                else {
                    // console.log(res.data)
                    // setTotalCount([])
                    // setResponseData([])
                    // setAvailableFilters([])
                    settransporterData(res.data.transporter_list)
                    settransporterCount(res.data.transporters_count)
                    // setTotalCount(res.data.transporters_count)
                    // setResponseData(res.data)
                    // res.data.filters.map((item) => {
                    //     setAvailableFilters(prevItem => [...prevItem, { label: `${item.type}`, value: item.type, ...item }])
                    // })
                    // var data = res.data.transporter_list
                    // var temp = []
                    // for (var i = 0; i < data.length; i++) {
                    //     temp.push(data[i])
                    // }
                    // settransporterData(temp)
                }
                setloading(false)


            })
            .catch(err => {
                // settransporterData([])
                // setTotalCount([])
                // setResponseData([])
                // setAvailableFilters([]);
                // setShow(false)
                setloading(false)

            })
    }

    const changeHandler = (e) => {
        setsubmitText(e.target.value)
    }

    const findResults = (e) => {
        // console.log(location)
        Activity([{
            "screen": "LoRRI-Search", "module": "Result-Search", "user_activity": `Search Query: ${submitText}`, "timestamp": currentRequestTimeStamp(), "userEmail": userDetails?.email, "userName": userDetails?.user_name, companyname:userDetails.company_name
                ? userDetails.company_name
                : userDetails.email
                    ? userDetails.email.split("@")[1].split(".")[0]
                    : ""
        }])
        // setdata([])
        // setmodule_filter([])
        // settransporterData([])

        // api call
        if (audio_input) {
            setactivePage(1)
            setaudio_input(false)
            setsubmitText(transcript)
            // api call with transcript as text
            settransporterData([])
            settransporterCount([])
            // api call with Submit text as text 
            setshow(true)
            // axios.post("https://lorrisearchv2.azurewebsites.net/api/lorrisearch", {
            axios.post(`${Urls.search_results}`, {
                "text": transcript.toLowerCase()
            })
                .then(res => {
                    getDiscovernowData(res.data.data)
                    setbigData(res.data.data)
                    setfilterdata(res.data.filters)
                    var temp = res.data.data
                    // var filters = []
                    var modules = []
                    var origins = []
                    var destinations = []
                    temp.map(item => {
                        if (item.module_name) {
                            modules.push(item.module_name)
                        }
                        if (item.origin) {
                            origins.push(item.origin)
                        }
                        if (item.destination) {
                            destinations.push(item.destination)
                        }
                    })

                    var unique_modules = [...new Set(modules)]
                    var final_modules = []
                    unique_modules.map(item => {
                        final_modules.push({ "value": item, "selected": false })
                    })
                    setmodule_filter(final_modules)
                    setuniqueModules(unique_modules)
                    var unique_origins = [...new Set(origins)]
                    var final_origins = []
                    unique_origins.map(item => {
                        final_origins.push({ "value": item, "selected": false })
                    })
                    // setorigin_filter(final_origins)

                    var unique_destinations = [...new Set(destinations)]
                    var final_destinations = []
                    unique_destinations.map(item => {
                        final_destinations.push({ "value": item, "selected": false })
                    })
                    final_destinations.map(item => {
                        final_origins.push(item)
                    })
                    var unique_final_origin = [...new Set(final_origins)]
                    setorigin_filter(unique_final_origin)
                    setoriginalData(res.data.data)
                    if (unique_modules.includes("Transporter Profile") && !unique_modules.includes("Compare Now")) {
                        const data1 = res.data.data
                        // console.log(data1)
                        const top10 = data1.slice(0, 10)
                        settransporterData(top10)
                        // settransporterCount(top10.length)

                        // const slice = data1.slice(0,1)
                        const slice = data1.slice(0, 10 + perpage)
                        // console.log(slice)

                        if (slice.length === 0) {
                            setdata(top10)
                        }
                        else {
                            setdata(slice)
                        }
                        // setdata(slice)
                        setoffset(10)

                        setpageCount(Math.ceil((data1.length - 10) / perpage))
                    }
                    else {
                        const data1 = res.data.data
                        // console.log(data1)
                        // const top10 = data1.slice(0,10)
                        // settransporterData(top10)
                        // const slice = data1.slice(0,1)
                        const offset1 = 0
                        const slice = data1.slice(offset1, offset1 + perpage)
                        // console.log(slice)
                        setdata(slice)
                        setpageCount(Math.ceil(data1.length / perpage))
                    }
                    // const data1 = res.data.data
                    // console.log(data1)
                    // // const slice = data1.slice(0,1)
                    // const slice = data1.slice(offset, offset + perpage)
                    // console.log(slice)
                    // setdata(slice)
                    // setpageCount(Math.ceil(data1.length / perpage))
                    // setdata(location.state.data)
                    // setsubmitText(location.state.searchquery)
                    setshow(false)
                })
                .catch(err => {
                    console.log(err)
                    setshow(false)
                })
            // console.log(transcript)
        }
        else {
            // console.log("else")
            // setactivePage(1)
            setaudio_input(false)
            settransporterData([])
            settransporterCount([])
            // api call with Submit text as text 
            setshow(true)
            // axios.post("https://lorrisearchv2.azurewebsites.net/api/lorrisearch", {
            if (submitText) {
                // console.log('inside submit')
                axios.post(`${Urls.search_results}`, {
                    // "text": "I want transporters from mumbai"
                    "text": submitText
                })
                    .then(res => {
                        document.getElementById('suggestions').style.display = "block"
                        var stateObj = { data: res.data.data, searchquery: submitText }
                        history.replace({ state: stateObj })

                        getDiscovernowData(res.data.data)

                        setbigData(res.data.data)
                        setfilterdata(res.data.filters)
                        var temp = res.data.data
                        // var filters = []
                        var modules = []
                        var origins = []
                        var destinations = []
                        temp.map(item => {
                            if (item.module_name) {
                                modules.push(item.module_name)
                            }
                            if (item.origin) {
                                origins.push(item.origin)
                            }
                            if (item.destination) {
                                destinations.push(item.destination)
                            }
                        })

                        var unique_modules = [...new Set(modules)]
                        var final_modules = []
                        unique_modules.map(item => {
                            final_modules.push({ "value": item, "selected": false })
                        })

                        setmodule_filter(unique_modules.length > 0 ? final_modules : [{ value: "", selected: false }])
                        // console.log(unique_modules)
                        setuniqueModules(unique_modules)

                        var unique_origins = [...new Set(origins)]
                        var final_origins = []
                        unique_origins.map(item => {
                            final_origins.push({ "value": item, "selected": false })
                        })
                        // setorigin_filter(final_origins)

                        var unique_destinations = [...new Set(destinations)]
                        var final_destinations = []
                        unique_destinations.map(item => {
                            final_destinations.push({ "value": item, "selected": false })
                        })
                        final_destinations.map(item => {
                            final_origins.push(item)
                        })
                        var unique_final_origin = [...new Set(final_origins)]
                        setorigin_filter(unique_final_origin)
                        setoriginalData(res.data.data)
                        if (unique_modules.includes("Transporter Profile") && !unique_modules.includes("Compare Now")) {
                            const data1 = res.data.data
                            // console.log(data1)
                            const top10 = data1.slice(0, 10)
                            settransporterData(top10)
                            // settransporterCount(top10.length)

                            // const slice = data1.slice(0,1)
                            const slice = data1.slice(0, 10 + perpage)
                            // console.log(slice)
                            // setdata(top10)
                            if (slice.length === 0) {
                                setdata(top10)
                            }
                            else {
                                setdata(slice)
                            }
                            // setdata(slice)
                            setoffset(10)

                            setpageCount(Math.ceil((data1.length - 10) / perpage))
                        }
                        else {
                            // console.log("not lsps profile")
                            const data1 = res.data.data
                            // console.log(data1)
                            // const top10 = data1.slice(0,10)
                            // settransporterData(top10)
                            // const slice = data1.slice(0,1)
                            // console.log(offset)
                            const offset1 = 0
                            const slice = data1.slice(offset1, offset1 + perpage)
                            // console.log(slice)
                            setdata(slice)
                            setpageCount(Math.ceil(data1.length / perpage))
                        }
                        // const data1 = res.data.data
                        // const top10 = data1.slice(0,10)
                        // settransporterData(top10)
                        // // const slice = data1.slice(0,1)
                        // const slice = data1.slice(offset, offset + perpage)
                        // setdata(slice)
                        // setpageCount(Math.ceil(data1.length / perpage))
                        // setdata(location.state.data)
                        // setsubmitText(location.state.searchquery)
                        setshow(false)
                    })
                    .catch(err => {
                        console.log(err)
                        setshow(false)
                    })
            }
            else {
                setshow(false)
                toast.info('Search results cannot be empty')
            }
        }
    }
    const startRecording = (e) => {
        SpeechRecognition.startListening()
        setaudio_input(true)
    }
    // const rightElement = (data) => {


    //     if (data[0].module_name === "Transporter Profile") {
    //         return (
    //             <>

    //                 <div className="logo">
    //                     {/* {data[0].initials ? data[0].initials : "NA"} */}
    //                     <img style={{ borderRadius: "1000px", marginTop: "-18%" }} src="logo.png" alt="profile_logo " id="profile_logo_screen" src={getImageSrc(data[0].logo)} onError={e => imageFallBack(e)} className="profile-img" />

    //                 </div>

    //                 <div className="card custom-card" style={{ cursor: "pointer" }}
    //                     onClick={e => window.open(`https://company.lorri.in/tpmp/${encryptor(data[0].transporter_id, true)}`, "_blank", "noopener noreferrer")}
    //                 >

    //                     <div className="card-body">
    //                         {/* <a style={{ marginTop: "2px" }} className={`${classes['s-tname']}`}
    //                             href={`/tpmp/${encryptor(data[0].transporter_id, true)}`}
    //                             target="_blank"
    //                             rel="noopener noreferrer"> */}

    //                         <h3 style={{ textAlign: "center" }} className="card-title"><b>{Uppercase(data[0].title)}</b></h3>

    //                         <p style={{ textAlign: "center" }} className="card-text">
    //                             <Rating
    //                                 style={{ width: '102%' }}
    //                                 initialRating={data[0].star_rating}
    //                                 readonly={true}
    //                                 emptySymbol={`fa fa-star ${classes['star-1']}`}
    //                                 fullSymbol={`fa fa-star ${classes['star-1-selected']}`} />

    //                         </p>
    //                         <p style={{ textAlign: "center" }} className="card-text"> (Number of ratings : {data[0].number_rating})</p>
    //                         <p style={{ textAlign: "center" }} className="card-text">{data[0].description}</p>

    //                         {/* </a> */}

    //                     </div>
    //                 </div>


    //             </>
    //         )
    //     }
    //     else {
    //         return (
    //             <>

    //                 <div className="logo">
    //                     {data[0].initials ? data[0].initials : "NA"}
    //                 </div>

    //                 <div className="card custom-card" style={{ cursor: "pointer" }}
    //                     onClick={e => history.push(

    //                         {
    //                             pathname: `/${data[0].module_name === "Location Dashboard" ? "location" : data[0].module_name === "Benchmark Now" ? "BenchmarkNow" : data[0].module_name}`,
    //                             state: {
    //                                 data: {
    //                                     "lat": parseFloat(data[0].origin_lat ? data[0].origin_lat : 0),
    //                                     "lon": parseFloat(data[0].origin_lon ? data[0].origin_lon : 0),
    //                                     "location": data[0].origin ? data[0].origin : "",
    //                                     "district": data[0].origin_district ? data[0].origin_district : "",
    //                                     "state": data[0].origin_state ? data[0].origin_state : "",
    //                                     "origin": {
    //                                         "location_name": `${data[0].origin} , ${data[0].origin_district}, ${data[0].origin_state}`,
    //                                         "location": {
    //                                             lon: parseFloat(data[0].origin_lon ? data[0].origin_lon : 0),
    //                                             lat: parseFloat(data[0].origin_lat ? data[0].origin_lat : 0),
    //                                             'label': `${data[0].origin} , ${data[0].origin_district}, ${data[0].origin_state}`
    //                                         }
    //                                     },
    //                                     "inputOrigin": `${data[0].origin} , ${data[0].origin_district}, ${data[0].origin_state}`,
    //                                     "destination": {
    //                                         "location_name": `${data[0].destination}, ${data[0].destination_district}, ${data[0].destination_state}`,
    //                                         "location": {
    //                                             lon: parseFloat(data[0].destination_lon ? data[0].destination_lon : 0),
    //                                             lat: parseFloat(data[0].destination_lat ? data[0].destination_lat : 0),
    //                                             'label': `${data[0].destination}, ${data[0].destination_district}, ${data[0].destination_state}`
    //                                         }
    //                                     },

    //                                     "inputDestination": `${data[0].destination}, ${data[0].destination_district}, ${data[0].destination_state}`,
    //                                     "truck_type": data[0].truck_name,
    //                                     "destination_name": data[0].destination,
    //                                     "destination_district": data[0].destination_district,
    //                                     "destination_lat": data[0].destination_lat,
    //                                     "destination_lon": data[0].destination_lon,
    //                                     "destination_score": data[0].destination_score,
    //                                     "destination_state": data[0].destination_state,

    //                                     "origin_name": data[0].origin,
    //                                     "origin_district": data[0].origin_district,
    //                                     "origin_lat": data[0].origin_lat,
    //                                     "origin_lon": data[0].origin_lon,
    //                                     "origin_score": data[0].origin_score,
    //                                     "origin_state": data[0].origin_state,



    //                                 },
    //                                 from_search: true
    //                             }
    //                         }
    //                     )}
    //                 >

    //                     <div className="card-body">
    //                         <h3 style={{ textAlign: "center" }} className="card-title"><b>{data[0].module_name}</b></h3>
    //                         <p style={{ textAlign: "center" }} className="card-text">{data[0].description}</p>
    //                         <div className="row">
    //                             {/* <Map searched={[73.56235749999999, 18.5816211]}  currentSearchedLocation={"mumbai"} /> */}
    //                         </div>
    //                     </div>
    //                 </div>


    //             </>
    //         )
    //     }
    // }
    const searchEnter = (e) => {
        // console.log(e.key)
        if (e.key === 'Enter') {

            // Cancel the default action, if needed
            e.preventDefault();
            // Trigger the button element with a click
            document.getElementById("searchSubmit").click();
        }
    }
    const handlePageChange = (e) => {
        const prevactivepage = activePage

        setactivePage(e)

        const offset1 = module_filter[0].value === "Transporter Profile" ? ((e - 1) * perpage) + 10 : (e - 1) * perpage
        // console.log(offset1)
        setoffset(offset1)

        if (prevactivepage > e) {

            // console.log("prev")
            const data1 = originalData
            const upperlimit = offset1 + perpage
            const slice = data1.slice(offset1, upperlimit)
            setdata(slice)
            // setpageCount(Math.ceil(data1.length / perpage))
        }
        else {

            // console.log("next")
            const data1 = originalData
            const upperlimit = offset1 + perpage

            if (upperlimit >= originalData.length - 1) {

                const slice = data1.slice(offset1, upperlimit)
                setdata(slice)
                // setpageCount(Math.ceil(data1.length / perpage))
            }
            else {

                const slice = data1.slice(offset1, upperlimit)
                setdata(slice)
                // setpageCount(Math.ceil(data1.length / perpage))
            }

        }

    }
    const modulefilterSelected = (e, item) => {
        // console.log(e.target.id)
        // console.log(item)
        var ids = e.target.id
        var selected_item = item
        selected_item["selected"] = !selected_item["selected"]
        var temp = module_filter.slice()
        temp[ids] = selected_item
        setmodule_filter(temp)
        var list_to_search = []
        temp.map(item => {
            if (item.selected) {
                list_to_search.push(item.value)
            }
        })
        // console.log("list to search", list_to_search)

        var location_list_to_search = []
        var location_list = origin_filter.slice()
        location_list.map(item => {
            if (item.selected) {
                location_list_to_search.push(item.value)
            }
        })
        // console.log("location list to search", location_list_to_search)
        var original_list = bigData.slice()
        var new_list = []

        original_list.map(item => {
            if (location_list_to_search.length > 0 && list_to_search.length > 0) {
                if (list_to_search.includes(item.module_name) && location_list_to_search.includes(item.origin)) {
                    new_list.push(item)
                }
            }
            else if (location_list_to_search.length > 0 && list_to_search.length === 0) {
                if (location_list_to_search.includes(item.origin)) {
                    new_list.push(item)
                }
            }
            else {
                if (list_to_search.includes(item.module_name)) {
                    new_list.push(item)
                }
            }
            // else {
            //     if (list_to_search.includes(item.module_name)) {
            //         new_list.push(item)
            //     }
            // }

        })
        // console.log("new list", new_list)

        if (new_list.length === 0) {
            setoriginalData(original_list)
            const data1 = original_list
            // console.log("data", data1)
            // const slice = data1.slice(0,1)
            const slice = data1.slice(offset, offset + perpage)
            // console.log("data",slice)
            setdata(slice)
            // setpageCount(Math.ceil(data1.length / perpage))
        }
        else {
            setoriginalData(new_list)
            const data1 = new_list
            // console.log("data", data1)
            // const slice = data1.slice(0,1)
            const slice = data1.slice(offset, offset + perpage)
            // console.log("data",slice)
            setdata(slice)
            // setpageCount(Math.ceil(data1.length / perpage))
        }
        // var original_list = bigData.slice()
        // var new_list = []
        // original_list.map(item => {
        //     if (list_to_search.includes(item.module_name)) {
        //         new_list.push(item)
        //     }
        // })
        // console.log("new list", new_list)
        // if (new_list.length === 0) {
        //     setoriginalData(original_list)
        //     const data1 = original_list
        //     console.log("data", data1)
        //     // const slice = data1.slice(0,1)
        //     const slice = data1.slice(offset, offset + perpage)
        //     // console.log(slice)
        //     setdata(slice)
        //     setpageCount(Math.ceil(data1.length / perpage))
        // }
        // else {
        //     setoriginalData(new_list)
        //     const data1 = new_list
        //     console.log("data", data1)
        //     // const slice = data1.slice(0,1)
        //     const slice = data1.slice(offset, offset + perpage)
        //     // console.log("data",slice)
        //     setdata(slice)
        //     setpageCount(Math.ceil(data1.length / perpage))
        // }


    }
    const originfilterSelected = (e, item) => {

        // console.log(item)
        var ids = e.target.id
        var selected_item = item
        selected_item["selected"] = !selected_item["selected"]
        var temp = origin_filter.slice()
        temp[ids] = selected_item
        setorigin_filter(temp)

        var list_to_search = []
        temp.map(item => {
            if (item.selected) {
                list_to_search.push(item.value)
            }
        })
        // console.log("list to search", list_to_search)

        var module_list_to_search = []
        var module_list = module_filter.slice()
        module_list.map(item => {
            if (item.selected) {
                module_list_to_search.push(item.value)
            }
        })
        // console.log("module list to search", module_list_to_search)
        var original_list = bigData.slice()
        var new_list = []

        original_list.map(item => {
            if (module_list_to_search.length > 0 && list_to_search.length > 0) {
                if (list_to_search.includes(item.origin) && module_list_to_search.includes(item.module_name)) {
                    new_list.push(item)
                }
            }
            else if (module_list_to_search.length > 0 && list_to_search.length === 0) {
                if (module_list_to_search.includes(item.module_name)) {
                    new_list.push(item)
                }
            }
            else {
                if (list_to_search.includes(item.origin)) {
                    new_list.push(item)
                }
            }

        })
        // console.log("new list", new_list)

        if (new_list.length === 0) {
            setoriginalData(original_list)
            const data1 = original_list
            // console.log("data", data1)
            // const slice = data1.slice(0,1)
            const slice = data1.slice(offset, offset + perpage)
            // console.log("data",slice)
            setdata(slice)
            // setpageCount(Math.ceil(data1.length / perpage))
        }
        else {
            setoriginalData(new_list)
            const data1 = new_list
            // console.log("data", data1)
            // const slice = data1.slice(0,1)
            const slice = data1.slice(offset, offset + perpage)
            // console.log("data",slice)
            setdata(slice)
            // setpageCount(Math.ceil(data1.length / perpage))
        }

    }
    // const marketingElement = (data) => {
    //     // console.log(module_filter)
    //     var module_list = []
    //     module_filter.map(item => {
    //         module_list.push(item.value)
    //     }
    //     )
    //     if (module_list.includes("DiscoverNow") || module_list.includes("Benchmark Now")) {
    //         const CarouselList = [
    //             {
    //                 image: subscribe,
    //                 title: "Upgrade Now",
    //                 description: `
    //                     View and select the most suitable LoRRI Plan for you.

    //                 `,
    //                 link: 'https://company.lorri.in/billing'
    //             },
    //             {
    //                 image: business_reach,
    //                 title: "Expand Reach & Business",
    //                 description: `Find untapped distribution channels and markets for your products and expand your reach and business`,
    //                 link: 'https://company.lorri.in/DiscoverNow'
    //             },
    //             {
    //                 image: freight_benchmarking,
    //                 title: "Get Freight Benchmark",
    //                 description: `We are creating the National Freight Benchmark, for transportation and shipping for major global markets`,
    //                 link: 'https://company.lorri.in/BenchmarkNow'
    //             },


    //             {
    //                 image: globe,
    //                 title: "Procure Freight",
    //                 description: `Run procurements and auctions for all your requirements`,
    //                 link: 'https://procurement.lorri.in'
    //             },
    //             {
    //                 image: truck,
    //                 title: "Trucks Available",
    //                 description: `Discover trucks available at various locations, thus enabling an ad-hoc marketplace`,
    //                 link: 'https://company.lorri.in/trucks'
    //             },
    //         ];
    //         return (
    //             <>
    //                 {/* <div style={{ display: "flex", flexDirection: "row", width: "120%" }}>
    //                     <div className="balloon"></div>
    //                     <div className="balloon"></div>
    //                     <div className="balloon"></div>
    //                     <div className="balloon"></div>
    //                     <div className="balloon"></div>
    //                 </div> */}
    //                 <div style={{ marginTop: '5%', marginLeft: '5%' }} className="row s10 m10 l10 xl10">
    //                     {CarouselList.map(item => (
    //                         <>
    //                             <a href={item.link} target="_blank" rel="noopener noreferrer" >
    //                                 {/* {item.title === "Upgrade Now" ?
    //                                 <div style={{ display: "flex", flexDirection: "row" }}>
    //                                     <div className="balloon"></div>
    //                                     <div className="balloon"></div>
    //                                     <div className="balloon"></div>
    //                                     <div className="balloon"></div>
    //                                     <div className="balloon"></div>
    //                                 </div>
    //                                 : null} */}
    //                                 <div align="center" className="custom-slider-card">

    //                                     <div style={{ padding: '0%', height: '22vh' }} className="col-sm-5">
    //                                         <img style={{ borderRadius: "20px", height: '100%', marginLeft: "-0.5%" }} src={item.image} />

    //                                     </div>
    //                                     <div className="col-sm-7">

    //                                         <div className="header">
    //                                             <span style={{ fontSize: 'large' }} className="card-title"><b>{item.title === "Upgrade Now" ? "Premium Plans" : item.title}</b></span>
    //                                         </div>
    //                                         {/* {item.title === "Upgrade Now" ?
    //                                             <div style={{ display: "flex", flexDirection: "row" }}>
    //                                                 <div className="balloon"></div>
    //                                                 <div className="balloon"></div>
    //                                                 <div className="balloon"></div>
    //                                                 <div className="balloon"></div>
    //                                                 <div className="balloon"></div>
    //                                             </div>
    //                                             : null} */}
    //                                         <div className="hidden-description">{item.description} {item.title === "Upgrade Now" ? <button style={{ marginTop: '12%' }} className="btn btn-success pulse-button">Launch Offer</button> : null}</div>
    //                                     </div>
    //                                 </div>
    //                             </a>
    //                             <br />
    //                         </>

    //                     ))}
    //                 </div>
    //             </>
    //         );
    //     }
    //     else if (module_list.includes("Location Dashboard")) {
    //         const CarouselList = [
    //             {
    //                 image: subscribe,
    //                 title: "Upgrade Now",
    //                 description: `
    //                     View and select the most suitable LoRRI Plan for you.

    //                 `,
    //                 link: 'https://company.lorri.in/billing'
    //             },
    //             {
    //                 image: logistics_intelligence,
    //                 title: "Logistics Intelligence",
    //                 description: `Get trusted data intelligence for logistics, spanning transportation & shipping world-wide`,
    //                 link: 'https://company.lorri.in/location'
    //             },

    //         ];
    //         return (
    //             <div style={{ marginTop: '5%', marginLeft: '5%' }} className="row s10 m10 l10 xl10">
    //                 {CarouselList.map(item => (
    //                     <>
    //                         <a href={item.link} target="_blank" rel="noopener noreferrer" >
    //                             <div align="center" className="custom-slider-card">
    //                                 <div style={{ padding: '0%', height: '22vh' }} className="col-sm-5">
    //                                     <img style={{ borderRadius: "20px", height: '100%', marginLeft: "-0.5%" }} src={item.image} />

    //                                 </div>
    //                                 <div className="col-sm-7">

    //                                     <div className="header">
    //                                         <span style={{ fontSize: 'large' }} className="card-title"><b>{item.title === "Upgrade Now" ? "Premium Plans" : item.title}</b></span>
    //                                     </div>
    //                                     {/* {item.title === "Upgrade Now" ?
    //                                         <div style={{ display: "flex", flexDirection: "row" }}>
    //                                             <div className="balloon"></div>
    //                                             <div className="balloon"></div>
    //                                             <div className="balloon"></div>
    //                                             <div className="balloon"></div>
    //                                             <div className="balloon"></div>
    //                                         </div>
    //                                         : null} */}
    //                                     <div className="hidden-description">{item.description} {item.title === "Upgrade Now" ? <button style={{ marginTop: '12%' }} className="btn btn-success pulse-button">Launch Offer</button> : null}</div>
    //                                 </div>
    //                             </div>
    //                         </a>
    //                         <br />
    //                     </>

    //                 ))}
    //             </div>
    //         );
    //     }

    //     else if (module_list.includes("Transporter Profile") && module_list.includes("Compare Now")) {
    //         const CarouselList = [
    //             {
    //                 image: subscribe,
    //                 title: "Upgrade Now",
    //                 description: `
    //                     View and select the most suitable LoRRI Plan for you

    //                 `,
    //                 link: 'https://company.lorri.in/billing'
    //             },
    //             {
    //                 image: optimization,
    //                 title: "Compare Transporters",
    //                 description: `Compare various transporters based on your desired parameters`,
    //                 link: 'https://company.lorri.in/TransportComparison'
    //             },
    //             {
    //                 image: business_reach1,
    //                 title: "Rate Transporters",
    //                 description: `Provide rating for your transporter and also find industry ratings`,
    //                 link: 'https://company.lorri.in/myTransporters'
    //             },
    //         ];

    //         return (

    //             <>
    //                 <div style={{ marginTop: '5%', marginLeft: '5%' }} className="row s10 m10 l10 xl10">
    //                     {CarouselList.map(item => (
    //                         <>
    //                             <a href={item.link} target="_blank" rel="noopener noreferrer" >
    //                                 <div align="center" className="custom-slider-card">
    //                                     <div style={{ padding: '0%', height: '22vh' }} className="col-sm-5">
    //                                         <img style={{ borderRadius: "20px", height: '100%', marginLeft: "-0.5%" }} src={item.image} />

    //                                     </div>
    //                                     <div className="col-sm-7">

    //                                         <div className="header">
    //                                             <span style={{ fontSize: 'large' }} className="card-title"><b>{item.title === "Upgrade Now" ? "Premium Plans" : item.title}</b></span>
    //                                         </div>
    //                                         {/* {item.title === "Upgrade Now" ?
    //                                             <div style={{ display: "flex", flexDirection: "row" }}>
    //                                                 <div className="balloon"></div>
    //                                                 <div className="balloon"></div>
    //                                                 <div className="balloon"></div>
    //                                                 <div className="balloon"></div>
    //                                                 <div className="balloon"></div>
    //                                             </div>
    //                                             : null} */}
    //                                         <div className="hidden-description">{item.description} {item.title === "Upgrade Now" ? <button style={{ marginTop: '12%' }} className="btn btn-success pulse-button">Launch Offer</button> : null}</div>
    //                                     </div>
    //                                 </div>
    //                             </a>
    //                             <br />
    //                         </>

    //                     ))}
    //                 </div>
    //             </>
    //         );
    //     }
    //     else if (module_list.includes("Compare Now")) {
    //         const CarouselList = [
    //             {
    //                 image: subscribe,
    //                 title: "Upgrade Now",
    //                 description: `
    //                     View and select the most suitable LoRRI Plan for you

    //                 `,
    //                 link: 'https://company.lorri.in/billing'
    //             },
    //             {
    //                 image: optimization,
    //                 title: "Compare Transporters",
    //                 description: `Discover the best fit transporter and make informed decisions basis industry relevant parameters`,
    //                 link: 'https://company.lorri.in/TransportComparison'
    //             },
    //             {
    //                 image: business_reach1,
    //                 title: "Rate Transporters",
    //                 description: `Discover the best fit transporter and make informed decisions basis industry relevant parameters`,
    //                 link: 'https://company.lorri.in/myTransporters'
    //             },
    //         ];

    //         return (

    //             <>
    //                 <div style={{ marginTop: '5%', marginLeft: '5%' }} className="row s10 m10 l10 xl10">
    //                     {CarouselList.map(item => (
    //                         <>
    //                             <a href={item.link} target="_blank" rel="noopener noreferrer" >
    //                                 <div align="center" className="custom-slider-card">
    //                                     <div style={{ padding: '0%', height: '22vh' }} className="col-sm-5">
    //                                         <img style={{ borderRadius: "20px", height: '100%', marginLeft: "-0.5%" }} src={item.image} />

    //                                     </div>
    //                                     <div className="col-sm-7">

    //                                         <div className="header">
    //                                             <span style={{ fontSize: 'large' }} className="card-title"><b>{item.title === "Upgrade Now" ? "Premium Plans" : item.title}</b></span>
    //                                         </div>
    //                                         {/* {item.title === "Upgrade Now" ?
    //                                             <div style={{ display: "flex", flexDirection: "row" }}>
    //                                                 <div className="balloon"></div>
    //                                                 <div className="balloon"></div>
    //                                                 <div className="balloon"></div>
    //                                                 <div className="balloon"></div>
    //                                                 <div className="balloon"></div>
    //                                             </div>
    //                                             : null} */}
    //                                         <div className="hidden-description">{item.description} {item.title === "Upgrade Now" ? <button style={{ marginTop: '12%' }} className="btn btn-success pulse-button">Launch Offer</button> : null}</div>
    //                                     </div>
    //                                 </div>
    //                             </a>
    //                             <br />
    //                         </>

    //                     ))}
    //                 </div>
    //             </>
    //         );
    //     }

    //     else if (module_list.includes("Transporter Profile")) {
    //         const CarouselList = [
    //             {
    //                 image: subscribe,
    //                 title: "Upgrade Now",
    //                 description: `
    //                     View and select the most suitable LoRRI Plan for you

    //                 `,
    //                 link: 'https://company.lorri.in/billing'
    //             },
    //             {
    //                 image: optimization,
    //                 title: "Compare Transporters",
    //                 description: `Discover the best fit transporter and make informed decisions basis industry relevant parameters`,
    //                 link: 'https://company.lorri.in/TransportComparison'
    //             },
    //             {
    //                 image: business_reach1,
    //                 title: "Rate Transporters",
    //                 description: `Discover the best fit transporter and make informed decisions basis industry relevant parameters`,
    //                 link: 'https://company.lorri.in/myTransporters'
    //             },
    //         ];

    //         return (

    //             <>

    //                 {/* <div className="logo">
    //                     <img style={{ borderRadius: "1000px", marginTop: "-18%" }} src="logo.png" alt="profile_logo " id="profile_logo_screen" src={getImageSrc(data[0].logo)} onError={e => imageFallBack(e)} className="profile-img" />

    //                 </div>

    //                 <div className="card custom-card" style={{ cursor: "pointer" }}
    //                     onClick={e => window.open(`/tpmp/${encryptor(data[0].transporter_id, true)}`, "_blank")}
    //                 >
    //                     <div className="card-body">
    //                                                     <h3 style={{ textAlign: "center" }} className="card-title"><b>{Uppercase(data[0].title)}</b></h3>

    //                         <p style={{ textAlign: "center" }} className="card-text">
    //                             <Rating
    //                                 style={{ width: '102%' }}
    //                                 initialRating={data[0].star_rating}
    //                                 readonly={true}
    //                                 emptySymbol={`fa fa-star ${classes['star-1']}`}
    //                                 fullSymbol={`fa fa-star ${classes['star-1-selected']}`} />

    //                         </p>
    //                         <p style={{ textAlign: "center" }} className="card-text"> (Number of ratings : {data[0].number_rating})</p>
    //                         <p style={{ textAlign: "center" }} className="card-text">{data[0].description}</p>


    //                     </div>
    //                 </div> */}




    //                 <div style={{ marginTop: '5%', marginLeft: '5%' }} className="row s10 m10 l10 xl10">
    //                     {CarouselList.map(item => (
    //                         <>
    //                             <a href={item.link} target="_blank" rel="noopener noreferrer" >
    //                                 <div align="center" className="custom-slider-card">
    //                                     <div style={{ padding: '0%', height: '22vh' }} className="col-sm-5">
    //                                         <img style={{ borderRadius: "20px", height: '100%', marginLeft: "-0.5%" }} src={item.image} />

    //                                     </div>
    //                                     <div className="col-sm-7">

    //                                         <div className="header">
    //                                             <span style={{ fontSize: 'large' }} className="card-title"><b>{item.title === "Upgrade Now" ? "Premium Plans" : item.title}</b></span>
    //                                         </div>
    //                                         {/* {item.title === "Upgrade Now" ?
    //                                             <div style={{ display: "flex", flexDirection: "row" }}>
    //                                                 <div className="balloon"></div>
    //                                                 <div className="balloon"></div>
    //                                                 <div className="balloon"></div>
    //                                                 <div className="balloon"></div>
    //                                                 <div className="balloon"></div>
    //                                             </div>
    //                                             : null} */}
    //                                         <div className="hidden-description">{item.description} {item.title === "Upgrade Now" ? <button style={{ marginTop: '12%' }} className="btn btn-success pulse-button">Launch Offer</button> : null}</div>
    //                                     </div>
    //                                 </div>
    //                             </a>
    //                             <br />
    //                         </>

    //                     ))}
    //                 </div>
    //             </>
    //         );
    //     }
    // }
    const searchSuggestions = (e, item) => {

        setsubmitText(item)
        // findResults()
        setaudio_input(false)
        settransporterData([])
        settransporterCount([])
        // api call with Submit text as text 
        setshow(true)
        // axios.post("https://lorrisearchv2.azurewebsites.net/api/lorrisearch", {
        axios.post(`${Urls.search_results}`, {

            // "text": "I want transporters from mumbai"
            "text": item

        })
            .then(res => {
                getDiscovernowData(res.data.data)

                setbigData(res.data.data)
                setfilterdata(res.data.filters)
                var temp = res.data.data
                // var filters = []
                var modules = []
                var origins = []
                var destinations = []
                temp.map(item => {
                    if (item.module_name) {
                        modules.push(item.module_name)
                    }
                    if (item.origin) {
                        origins.push(item.origin)
                    }
                    if (item.destination) {
                        destinations.push(item.destination)
                    }
                })

                var unique_modules = [...new Set(modules)]
                var final_modules = []
                unique_modules.map(item => {
                    final_modules.push({ "value": item, "selected": false })
                })

                setmodule_filter(unique_modules.length > 0 ? final_modules : [{ value: "", selected: false }])
                // console.log(unique_modules)
                setuniqueModules(unique_modules)
                var unique_origins = [...new Set(origins)]
                var final_origins = []
                unique_origins.map(item => {
                    final_origins.push({ "value": item, "selected": false })
                })
                // setorigin_filter(final_origins)

                var unique_destinations = [...new Set(destinations)]
                var final_destinations = []
                unique_destinations.map(item => {
                    final_destinations.push({ "value": item, "selected": false })
                })
                final_destinations.map(item => {
                    final_origins.push(item)
                })
                var unique_final_origin = [...new Set(final_origins)]
                setorigin_filter(unique_final_origin)
                setoriginalData(res.data.data)
                if (unique_modules.includes("Transporter Profile") && !unique_modules.includes("Compare Now")) {
                    const data1 = res.data.data
                    // console.log(data1)
                    const top10 = data1.slice(0, 10)
                    settransporterData(top10)
                    // settransporterCount(top10.length)

                    // const slice = data1.slice(0,1)
                    const slice = data1.slice(10, 10 + perpage)
                    // console.log(slice)
                    if (slice.length === 0) {
                        setdata(top10)
                    }
                    else {
                        setdata(slice)
                    }
                    // setdata(slice)
                    setoffset(10)

                    setpageCount(Math.floor((data1.length - 10) / perpage))
                }
                else {
                    const data1 = res.data.data
                    // console.log(data1)
                    // const top10 = data1.slice(0,10)
                    // settransporterData(top10)
                    // const slice = data1.slice(0,1)
                    const offset1 = 0
                    const slice = data1.slice(offset1, offset1 + perpage)
                    // console.log(slice)
                    setdata(slice)
                    setpageCount(Math.ceil(data1.length / perpage))
                }
                // const data1 = res.data.data
                // console.log(data1)
                // const top10 = data1.slice(0,10)
                // settransporterData(top10)
                // // const slice = data1.slice(0,1)
                // const slice = data1.slice(offset, offset + perpage)
                // console.log(slice)
                // setdata(slice)
                // setpageCount(Math.ceil(data1.length / perpage))
                // setdata(location.state.data)
                // setsubmitText(location.state.searchquery)
                setshow(false)
            })
            .catch(err => {
                console.log(err)
                setshow(false)
            })
        // console.log(submitText)
        // document.getElementById("searchSubmit").click()
    }
    const noResults = (e) => {
        // console.log('no results')
        settrueresults(false)
        setshow(true)
        // axios.post("https://lorrisearchv2.azurewebsites.net/api/search_log", {
        axios.post(`${Urls.search_log}`, {
            "tracking_data": {
                "search_query": submitText,
                "search_results": filterdata,
            }
        })
            .then(res => {
                setshow(false)
                document.getElementById('suggestions').style.display = "none"
                toast.success("Thankyou for your feedback!")
            })
            .catch(err => {
                setshow(false)
                console.log(err)
                // toast.success("Thankyou for your feedback!")
            })
    }

    return (
        <div>
            <Loader show={show} />
            <div className="row">
                {/* <div className="col-md-1">
                <div style={{marginLeft: "10%", marginTop: '10%'}}> */}
                {/* <div>
                        <span style={{fontSize: '24px', fontWeight: 'bold'}}>Filters</span><hr/>
                    </div> */}
                {/* {filterdata && filterdata["ZONE"] && filterdata["ZONE"].length > 0 ? 
                        <>
                            <span style={{fontSize: '18px', fontWeight: 'bold'}}>Zone</span>
                            {filterdata["ZONE"].map(r => {
                                return <div>
                                    <div style={{display: 'flex'}}><input type="checkbox" className="check-w"/><span style={{marginTop: '5%', marginLeft: '2%'}}>{r}</span></div>
                                </div>
                            })}<hr />
                        </>
                    : null
                    } */}
                {/* {filterdata && filterdata["TRUCK"] ? 
                        <>
                            <span style={{fontSize: '18px', fontWeight: 'bold'}}>Truck Type</span>
                            {filterdata["TRUCK"].map(r => {
                                console.log(r)
                                return <div>
                                    <div style={{display: 'flex'}}>
                                        <input type="checkbox" className="check-w"/>
                                        <span style={{marginTop: '5%', marginLeft: '2%'}}>{r.truck_type}</span>
                                    </div>
                                </div>
                            })}<hr />
                        </>
                    : null
                    } */}
                {/* </div>
            </div> */}
                <div className="col-md-12">
                    <div style={{ position: "sticky", top: "0%", fontSize: "20px", backgroundColor: "white", zIndex: '10' }} className="row"> {/* zIndex:998 */}
                        <div className="search-bar">
                            {audio_input ?
                                <input className="search-bar-input" value={transcript} type="text" placeholder="Search" aria-label="Search" />
                                :
                                <>
                                    <input className="search-bar-input" value={submitText} onChange={e => changeHandler(e)}
                                        type="text" placeholder="Search" aria-label="Search" />
                                    {/* <div>
                            <Autosuggestor value={submitText} onChange={e => changeHandler(e)} onSelect={e => setsubmitText(e)} 
                                getResults={e => onSearchSubmit(e, "autocomplete")} 
                            />
                        </div> */}
                                </>
                            }
                            {!isMobile() ?
                                <>
                                    {/* <i title="Search by voice" onClick={e => startRecording(e)} style={{ fontSize: "xx-large", padding: "1%", cursor: 'pointer', color: "#393186" }} className="fas fa-microphone"></i> */}
                                    <i id="searchSubmit" onClick={e => findResults(e)} style={{ fontSize: "xx-large", padding: "1% 1% 1% 0%", cursor: 'pointer', color: "#393186" }} className="fas fa-search"></i>
                                </>
                                :
                                <>
                                    {/* <i title="Search by voice" onClick={e => startRecording(e)} style={{ paddingTop: "2%", cursor: 'pointer', color: "#393186" }} className="fas fa-microphone"></i> */}
                                    <i id="searchSubmit" onClick={e => findResults(e)} style={{ padding: "2% 2% 1% 2%", cursor: 'pointer', color: "#393186" }} className="fas fa-search"></i>
                                </>
                            }
                        </div>
                    </div>
                    {/* <div className="container"> */}
                    <div className="" style={{ marginLeft: '2%' }}>

                        {/* <div className="bar">
                    <input className="searchbar" type="text" title="Search" />
                    <a href="#"> <img className="voice" src="https://upload.wikimedia.org/wikipedia/commons/thumb/e/e8/Google_mic.svg/716px-Google_mic.svg.png" title="Search by Voice" /></a>
                </div> */}


                        <div className="row">
                            <div className="collapse" id="collapseExample">
                                <div style={{ marginTop: '0.5%' }} className="row filterrow">
                                    <div className="col-sm-1">
                                        {module_filter.length > 0 ?
                                            <>
                                                Module:
                                            </>
                                            :
                                            null}
                                    </div>
                                    <div className="col-sm-11 wrap-text">
                                        {module_filter.length > 0 ?

                                            module_filter.map((item, index) => (
                                                <span key={index}>
                                                    {item.selected ?

                                                        <span id={index} onClick={e => modulefilterSelected(e, item)} className={"selected-filter"}>{item.value}</span>

                                                        :
                                                        <span id={index} onClick={e => modulefilterSelected(e, item)} className={"filters"}>{item.value}</span>

                                                    }
                                                </span>
                                            ))
                                            :
                                            null
                                        }
                                    </div>

                                </div>
                                <div className="row filterrow">
                                    <div className="col-sm-1">
                                        {origin_filter.length > 0 ?
                                            <>
                                                Locations:
                                            </>
                                            :
                                            null}
                                    </div>
                                    <div className="col-sm-11 wrap-text">
                                        {origin_filter.length > 0 ?

                                            origin_filter.map((item, index) => (
                                                <span key={index}>
                                                    {item.selected ?
                                                        <span id={index} onClick={e => originfilterSelected(e, item)} className={"selected-filter"}>{item.value}</span>
                                                        :
                                                        <span id={index} onClick={e => originfilterSelected(e, item)} className={"filters"}>{item.value}</span>

                                                    }
                                                </span>
                                            ))
                                            :
                                            null
                                        }
                                    </div>

                                </div>

                            </div>
                        </div>



                        <div className="row">
                            <div className="col-sm-6" style={{ marginLeft: '4%' }}>
                                {data.length > 0 && data[0] !== "No Data" ?
                                    <>
                                        <div id="suggestions" className="div-suggestions">
                                            <span style={{ fontSize: '16px' }}>Is the results relevant to your search?</span>
                                            <span>
                                                <button className="btn btn-sm btn-success yes-button" onClick={e => noResults(e)}>
                                                    Yes
                                                </button>
                                                <button className="btn btn-sm btn-secondary no-button" onClick={e => noResults(e)}>
                                                    No
                                                </button>
                                            </span><hr />
                                        </div>
                                        {/* {console.log(data)} */}
                                        <span style={{ marginLeft: '13px' }}>
                                            {/* <b>Showing {data.length}/{originalData.length} results</b> */}
                                            About <b>{originalData.length}</b> results
                                        </span><br />

                                        {data.length > 0 ? data.map((item, index) => (

                                            <span key={index}>
                                                {/* {console.log(module_filter)} */}

                                                {

                                                    module_filter[0].value === "Transporter Profile" && index === 0 && activePage === 1 ?
                                                        <>
                                                            <div key={index} className="card" style={{ cursor: "pointer", border: "1px solid rgba(0, 0, 0, 0.125)" }}> {/* zIndex:995 */}
                                                                <div className="card-body">
                                                                    {/* <span className="annotation">{item.link_annotation}</span> */}
                                                                    {/* <span className="first-annotation"><b>List of transporters from {item.title}</b></span> */}

                                                                    <span className="card-text">

                                                                        <span className="annotation">Showing top {transporterData.length} transporters</span>

                                                                        {transporterData.length > 0 ?
                                                                            transporterData.map((item, index) => (
                                                                                <>
                                                                                    <div key={index} className="card s-card-height" style={{ cursor: "pointer", border: "1px solid rgba(0, 0, 0, 0.125)", marginTop: '5px' }}>
                                                                                        <div className="card-body">
                                                                                            {window.innerWidth > 600 ?
                                                                                                <>
                                                                                                    <div className="row">
                                                                                                        <div className='col-sm-2'>
                                                                                                            <img height='40' width='40' style={{ borderRadius: "1000px" }} alt="profile_logo " id="profile_logo_screen" src={getImageSrc(item.logo)} onError={e => imageFallBack(e)} className="profile-img" />
                                                                                                            {/* <img height='40' width='40' style={{ borderRadius: "1000px" }} src="logo.png" alt="profile_logo " id="profile_logo_screen" src={getImageSrc(item.logo)} onError={e => imageFallBack(e)} className="profile-img" /> */}
                                                                                                        </div>
                                                                                                        <div className='col-sm-6'>
                                                                                                            {/* <span className="redirect" onClick={e => window.open(`https://company.lorri.in/tpmp/${encryptor(item.transporter_id, true)}`, "_blank", "noopener noreferrer")}>{Uppercase(item.title)}</span> */}
                                                                                                            <ProfileModal
                                                                                                                // transporter_list={item.transporter_list}
                                                                                                                transporter_id={item.transporter_id}
                                                                                                                transporter_name={item.title}
                                                                                                                screenName={'Search Results'}
                                                                                                                moduleName={'LoRRI Search'}
                                                                                                                className="redirect"
                                                                                                            // buttonClass={`${classes['own-modal-style']} btn-link`}
                                                                                                            />
                                                                                                        </div>
                                                                                                        <div className='col-sm-4'>
                                                                                                            <Rating
                                                                                                                style={{ width: '63%' }}
                                                                                                                initialRating={item.star_rating}
                                                                                                                readonly={true}
                                                                                                                emptySymbol={`fa fa-star ${classes['star-1']}`}
                                                                                                                fullSymbol={`fa fa-star ${classes['star-1-selected']}`} />
                                                                                                            <span>
                                                                                                                <span style={{ fontSize: "12px" }}><b>{item.star_rating ? parseFloat(item.star_rating).toFixed(2) : "-"}</b></span> / <span style={{ fontSize: "12px" }}>5</span></span>
                                                                                                            {/* <span style={{ fontSize: "large" }}><b>{item.star_rating}</b></span> / <span>5</span></span> */}
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <br />
                                                                                                </> :
                                                                                                <>
                                                                                                    <div style={{ display: 'inline-flex' }}>
                                                                                                        <span>
                                                                                                            <img height='40' width='40' style={{ borderRadius: "1000px" }} alt="profile_logo " id="profile_logo_screen" src={getImageSrc(item.logo)} onError={e => imageFallBack(e)} className="profile-img" />
                                                                                                        </span>
                                                                                                        <span style={{ width: '80%' }}>
                                                                                                            <ProfileModal
                                                                                                                transporter_id={item.transporter_id}
                                                                                                                transporter_name={item.transporter_name}
                                                                                                                screenName={'Search Results'}
                                                                                                                moduleName={'LoRRI Search'}
                                                                                                            />
                                                                                                        </span>
                                                                                                        <span style={{ width: '27%' }}>
                                                                                                            <Rating
                                                                                                                style={{ width: '100%' }}
                                                                                                                initialRating={item.overall_rating}
                                                                                                                readonly={true}
                                                                                                                emptySymbol={`fa fa-star ${classes['star-1']}`}
                                                                                                                fullSymbol={`fa fa-star ${classes['star-1-selected']}`}
                                                                                                            />
                                                                                                        </span>
                                                                                                        <span>
                                                                                                            <span style={{ fontSize: "large" }}><b>{item.overall_rating ? parseFloat(item.overall_rating).toFixed(2) : "-"}</b></span> / <span>5</span>
                                                                                                        </span>
                                                                                                    </div>
                                                                                                </>
                                                                                            }

                                                                                        </div>
                                                                                    </div>
                                                                                </>
                                                                            ))
                                                                            :
                                                                            <span>
                                                                                <Loader show={loading} />
                                                                            </span>

                                                                        }
                                                                    </span>


                                                                </div>
                                                            </div>
                                                            {/* <div className="card view-all-button-div">
                                                        <button onClick={e => history.push({ pathname: "/DiscoverNow" })} className="view-all-button"><i style={{ float: 'left', marginTop: '1.5%' }} className="fas fa-arrow-right"></i><span>View All</span></button>
                                                    </div> */}
                                                        </>
                                                        :
                                                        item.module_name === "Transporter Profile" ?

                                                            <div className="card" style={{ cursor: "pointer" }}
                                                                onClick={e => window.open(`https://company.lorri.in/tpmp/${encryptor(data[index].transporter_id, true)}`, "_blank", "noopener noreferrer")}>
                                                                <div className="card-body">
                                                                    <span className="annotation">{item.link_annotation}</span>
                                                                    <h3 style={{ marginTop: "1%" }} className="card-title redirect"><b><u></u>{item.title}</b></h3>
                                                                    <br />
                                                                    <p className="card-text redirect">{item.description}</p>
                                                                    <p className="card-text redirect">
                                                                        {item.zone.length > 0 && item.zone[0] !== "" ?
                                                                            <>
                                                                                <b>Zone:</b> {item.zone.map((data, index) => (
                                                                                    <span key={index}>{index >= item.zone.length - 1 ?
                                                                                        <>
                                                                                            <span>{data} </span>
                                                                                        </>
                                                                                        :
                                                                                        <>
                                                                                            <span>{data},</span>
                                                                                        </>
                                                                                    }
                                                                                    </span>
                                                                                ))}
                                                                            </>
                                                                            : null
                                                                        }
                                                                        {item.sectors.length > 0 && item.sectors[0] !== "" ?
                                                                            // <p className="card-text redirect">
                                                                            <>
                                                                                <b>|| Sector:</b> {item.sectors.map((data, index) => (
                                                                                    <span key={index}>{index >= item.sectors.length - 1 ?
                                                                                        <>
                                                                                            <span>{data} </span>
                                                                                        </>
                                                                                        :
                                                                                        <>
                                                                                            <span>{data},</span>
                                                                                        </>
                                                                                    }
                                                                                    </span>
                                                                                ))}
                                                                            </>
                                                                            // {/* </p> */}
                                                                            : null
                                                                        }
                                                                    </p>

                                                                </div>
                                                            </div>
                                                            :
                                                            item.module_name === "Compare Now" ?
                                                                <>
                                                                    <Modal
                                                                        buttonLabel={'CompareNow'}
                                                                        content={<Compare
                                                                            from_search={item.transporter_ids}
                                                                        // lsps_ids={item.title}
                                                                        />}
                                                                        id={item.title}
                                                                        className={'CompareNowModalBox'}
                                                                        title={item.title}
                                                                        // buttonclassName={`btn `}
                                                                        // <button type="button" className="btn btn-primary btn-sm">Small button</button>
                                                                        buttonClass={'no-button'}
                                                                        style={{ 'height': 'fit-content', 'font-size': 'medium', 'margin-top': '1%' }}
                                                                        overflowStyles={{ overflow: 'hidden' }}
                                                                    />
                                                                    <div className="card" style={{ cursor: "pointer" }}
                                                                        onClick={e => document.getElementById(`${item.title}`).click()}>
                                                                        <div className="card-body">
                                                                            <span className="annotation">{item.link_annotation}</span>
                                                                            <h3 style={{ marginTop: "1%" }} className="card-title redirect"><b><u></u>{item.title}</b></h3>

                                                                            <p className="card-text redirect">{item.description}</p>

                                                                        </div>
                                                                    </div>
                                                                </>
                                                                :
                                                                index === 0 && item.module_name !== "Benchmark Now"
                                                                    // && transporterData.length > 0
                                                                    && activePage === 1
                                                                    && module_filter[0].value !== ""
                                                                    ?
                                                                    // bada wala card
                                                                    // loading ?
                                                                    //     <CardLoader />
                                                                    // :

                                                                    <>

                                                                        {/* <div className="card" style={{ cursor: "pointer", border: "1px solid rgba(0, 0, 0, 0.125)" }}>
                                                                        <div className="card-body">
                                                                            <span className="first-annotation"><b>List of transporters from {item.title}</b></span>

                                                                            <span className="card-text"><br />

                                                                                <span className="annotation">Showing {transporterData.length}/{transporterCount} transporters</span>

                                                                                {transporterData.length >= 1 ?
                                                                                    transporterData.map((item, index) => (
                                                                                        <>
                                                                                            <div key={index} className="card s-card-height" style={{ cursor: "pointer",  border: "1px solid rgba(0, 0, 0, 0.125)" }}>
                                                                                                <div className="card-body">
                                                                                                    {window.innerWidth > 600 ? 
                                                                                                    <>
                                                                                                    <div className="row">
                                                                                                        <div className='col-sm-2'>
                                                                                                            <img height='40' width='40' style={{ borderRadius: "1000px" }} alt="profile_logo " id="profile_logo_screen" src={getImageSrc(item.logo)} onError={e => imageFallBack(e)} className="profile-img" />
                                                                                                        </div>
                                                                                                        <div className='col-sm-6'>
                                                                                                            <ProfileModal 
                                                                                                                transporter_id={item.transporter_id}
                                                                                                                transporter_name={item.transporter_name}
                                                                                                                screenName={'Search Results'}
                                                                                                                moduleName={'LoRRI Search'}
                                                                                                                className="redirect"
                                                                                                            />
                                                                                                        </div>
                                                                                                        <div className='col-sm-4'>
                                                                                                            <Rating
                                                                                                                style={{ width: '52%' }}
                                                                                                                initialRating={item.overall_rating}
                                                                                                                readonly={true}
                                                                                                                emptySymbol={`fa fa-star ${classes['star-1']}`}
                                                                                                                fullSymbol={`fa fa-star ${classes['star-1-selected']}`} />
                                                                                                            <span>
                                                                                                                <span style={{ fontSize: "large" }}><b>{item.overall_rating ? parseFloat(item.overall_rating).toFixed(2) : "-"}</b></span> / <span>5</span>
                                                                                                            </span>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <br />
                                                                                                    </> :
                                                                                                    <>
                                                                                                        <div style={{display: 'inline-flex'}}>
                                                                                                            <span>
                                                                                                                <img height='40' width='40' style={{ borderRadius: "1000px" }} alt="profile_logo " id="profile_logo_screen" src={getImageSrc(item.logo)} onError={e => imageFallBack(e)} className="profile-img" />
                                                                                                            </span>
                                                                                                            <span style={{width: '80%'}}>
                                                                                                                <ProfileModal 
                                                                                                                    transporter_id={item.transporter_id}
                                                                                                                    transporter_name={item.transporter_name}
                                                                                                                    screenName={'Search Results'}
                                                                                                                    moduleName={'LoRRI Search'}
                                                                                                                />
                                                                                                            </span>
                                                                                                            <span style={{width: '27%'}}>
                                                                                                                <Rating
                                                                                                                    style={{ width: '100%' }}
                                                                                                                    initialRating={item.overall_rating}
                                                                                                                    readonly={true}
                                                                                                                    emptySymbol={`fa fa-star ${classes['star-1']}`}
                                                                                                                    fullSymbol={`fa fa-star ${classes['star-1-selected']}`} 
                                                                                                                />
                                                                                                            </span>
                                                                                                            <span>
                                                                                                                <span style={{ fontSize: "large" }}><b>{item.overall_rating ? parseFloat(item.overall_rating).toFixed(2) : "-"}</b></span> / <span>5</span>
                                                                                                            </span>
                                                                                                        </div>
                                                                                                    </>
                                                                                                    }
                                                                                                </div>
                                                                                            </div>
                                                                                        </>
                                                                                    ))
                                                                                    :
                                                                                    <>
                                                                                        <br />
                                                                                        <span style={{ textAlign: "center" }}>
                                                                                            Sorry we could not find lsps catering to your need!
                                                                                        </span>
                                                                                    </>

                                                                                }
                                                                            </span><br />

                                                                            <span className="card-text redirect"
                                                                                onClick={e => history.push(
                                                                                    {
                                                                                        pathname: `/${item.module_name === "Location Dashboard" ? "locationdashboard" : item.module_name === "Benchmark Now" ? "BenchmarkNow" : item.module_name}`,
                                                                                        state: {
                                                                                            data: {
                                                                                                "lat": parseFloat(item.origin_lat ? item.origin_lat : 0),
                                                                                                "lon": parseFloat(item.origin_lon ? item.origin_lon : 0),
                                                                                                "location": item.origin ? item.origin : "",
                                                                                                "district": item.origin_district ? item.origin_district : "",
                                                                                                "state": item.origin_state ? item.origin_state : "",
                                                                                                "origin": {
                                                                                                    "location_name": `${item.origin} , ${item.origin_district}, ${item.origin_state}`,
                                                                                                    "location": {
                                                                                                        lon: parseFloat(item.origin_lon ? item.origin_lon : 0),
                                                                                                        lat: parseFloat(item.origin_lat ? item.origin_lat : 0),
                                                                                                        'label': `${item.origin} , ${item.origin_district}, ${item.origin_state}`
                                                                                                    }
                                                                                                },
                                                                                                "inputOrigin": `${item.origin} , ${item.origin_district}, ${item.origin_state}`,
                                                                                                "destination": {
                                                                                                    "location_name": `${item.destination}, ${item.destination_district}, ${item.destination_state}`,
                                                                                                    "location": {
                                                                                                        lon: parseFloat(item.destination_lon ? item.destination_lon : 0),
                                                                                                        lat: parseFloat(item.destination_lat ? item.destination_lat : 0),
                                                                                                        'label': `${item.destination}, ${item.destination_district}, ${item.destination_state}`
                                                                                                    }
                                                                                                },

                                                                                                "inputDestination": `${item.destination}, ${item.destination_district}, ${item.destination_state}`,
                                                                                                "truck_type": item.truck_name,
                                                                                                "destination_name": item.destination,
                                                                                                "destination_district": item.destination_district,
                                                                                                "destination_lat": item.destination_lat,
                                                                                                "destination_lon": item.destination_lon,
                                                                                                "destination_score": item.destination_score,
                                                                                                "destination_state": item.destination_state,

                                                                                                "origin_name": item.origin,
                                                                                                "origin_district": item.origin_district,
                                                                                                "origin_lat": item.origin_lat,
                                                                                                "origin_lon": item.origin_lon,
                                                                                                "origin_score": item.origin_score,
                                                                                                "origin_state": item.origin_state,
                                                                                                "filter_discovernow": [{
                                                                                                    "count": 36,
                                                                                                    "filter": "truck_type",
                                                                                                    "filter_label": "Truck Type",
                                                                                                    "isChecked": false,
                                                                                                    "label": item.truck_name,
                                                                                                    "type": item.truck_name,
                                                                                                    "value": item.truck_name
                                                                                                }],



                                                                                            },
                                                                                            from_search: true
                                                                                        }
                                                                                    })}
                                                                            >{item.description}</span>

                                                                        </div>
                                                                    </div> */}
                                                                        {/* <div className="card view-all-button-div">
                                                                        <button
                                                                            onClick={e => history.push(
                                                                                {
                                                                                    pathname: `/${item.module_name === "Location Dashboard" ? "locationdashboard" : item.module_name === "Benchmark Now" ? "BenchmarkNow" : item.module_name}`,
                                                                                    state: {
                                                                                        data: {
                                                                                            "lat": parseFloat(item.origin_lat ? item.origin_lat : 0),
                                                                                            "lon": parseFloat(item.origin_lon ? item.origin_lon : 0),
                                                                                            "location": item.origin ? item.origin : "",
                                                                                            "district": item.origin_district ? item.origin_district : "",
                                                                                            "state": item.origin_state ? item.origin_state : "",
                                                                                            "origin": {
                                                                                                "location_name": `${item.origin} , ${item.origin_district}, ${item.origin_state}`,
                                                                                                "location": {
                                                                                                    lon: parseFloat(item.origin_lon ? item.origin_lon : 0),
                                                                                                    lat: parseFloat(item.origin_lat ? item.origin_lat : 0),
                                                                                                    'label': `${item.origin} , ${item.origin_district}, ${item.origin_state}`
                                                                                                }
                                                                                            },
                                                                                            "inputOrigin": `${item.origin} , ${item.origin_district}, ${item.origin_state}`,
                                                                                            "destination": {
                                                                                                "location_name": `${item.destination}, ${item.destination_district}, ${item.destination_state}`,
                                                                                                "location": {
                                                                                                    lon: parseFloat(item.destination_lon ? item.destination_lon : 0),
                                                                                                    lat: parseFloat(item.destination_lat ? item.destination_lat : 0),
                                                                                                    'label': `${item.destination}, ${item.destination_district}, ${item.destination_state}`
                                                                                                }
                                                                                            },

                                                                                            "inputDestination": `${item.destination}, ${item.destination_district}, ${item.destination_state}`,
                                                                                            "truck_type": item.truck_name,
                                                                                            "destination_name": item.destination,
                                                                                            "destination_district": item.destination_district,
                                                                                            "destination_lat": item.destination_lat,
                                                                                            "destination_lon": item.destination_lon,
                                                                                            "destination_score": item.destination_score,
                                                                                            "destination_state": item.destination_state,

                                                                                            "origin_name": item.origin,
                                                                                            "origin_district": item.origin_district,
                                                                                            "origin_lat": item.origin_lat,
                                                                                            "origin_lon": item.origin_lon,
                                                                                            "origin_score": item.origin_score,
                                                                                            "origin_state": item.origin_state,
                                                                                            "filter_discovernow": [{
                                                                                                "count": 36,
                                                                                                "filter": "truck_type",
                                                                                                "filter_label": "Truck Type",
                                                                                                "isChecked": false,
                                                                                                "label": item.truck_name,
                                                                                                "type": item.truck_name,
                                                                                                "value": item.truck_name
                                                                                            }],



                                                                                        },
                                                                                        from_search: true
                                                                                    }
                                                                                })}
                                                                            className="view-all-button"><i style={{ float: 'left', marginTop: '1.5%' }} className="fas fa-arrow-right"></i><span>View All</span></button>
                                                                    </div> */}
                                                                    </>
                                                                    :
                                                                    <div className="card" style={{ cursor: "pointer" }}
                                                                        onClick={e => history.push(
                                                                            {
                                                                                pathname: `/${item.module_name === "Location Dashboard" ? "locationdashboard" : item.module_name === "Benchmark Now" ? "BenchmarkNow" : item.module_name}`,
                                                                                state: {
                                                                                    data: {
                                                                                        "lat": parseFloat(item.origin_lat ? item.origin_lat : 0),
                                                                                        "lon": parseFloat(item.origin_lon ? item.origin_lon : 0),
                                                                                        "location": item.origin ? item.origin : "",
                                                                                        "district": item.origin_district ? item.origin_district : "",
                                                                                        "state": item.origin_state ? item.origin_state : "",
                                                                                        "origin": {
                                                                                            "location_name": `${item.origin} , ${item.origin_district}, ${item.origin_state}`,
                                                                                            "location": {
                                                                                                lon: parseFloat(item.origin_lon ? item.origin_lon : 0),
                                                                                                lat: parseFloat(item.origin_lat ? item.origin_lat : 0),
                                                                                                'label': `${item.origin} , ${item.origin_district}, ${item.origin_state}`
                                                                                            }
                                                                                        },
                                                                                        "inputOrigin": `${item.origin} , ${item.origin_district}, ${item.origin_state}`,
                                                                                        "destination": {
                                                                                            "location_name": `${item.destination}, ${item.destination_district}, ${item.destination_state}`,
                                                                                            "location": {
                                                                                                lon: parseFloat(item.destination_lon ? item.destination_lon : 0),
                                                                                                lat: parseFloat(item.destination_lat ? item.destination_lat : 0),
                                                                                                'label': `${item.destination}, ${item.destination_district}, ${item.destination_state}`
                                                                                            }
                                                                                        },

                                                                                        "inputDestination": `${item.destination}, ${item.destination_district}, ${item.destination_state}`,
                                                                                        "truck_type": item.truck_name,
                                                                                        "destination_name": item.destination,
                                                                                        "destination_district": item.destination_district,
                                                                                        "destination_lat": item.destination_lat,
                                                                                        "destination_lon": item.destination_lon,
                                                                                        "destination_score": item.destination_score,
                                                                                        "destination_state": item.destination_state,

                                                                                        "origin_name": item.origin,
                                                                                        "origin_district": item.origin_district,
                                                                                        "origin_lat": item.origin_lat,
                                                                                        "origin_lon": item.origin_lon,
                                                                                        "origin_score": item.origin_score,
                                                                                        "origin_state": item.origin_state,
                                                                                        "truck_group": item.truck_group,
                                                                                        "filter_discovernow": [{
                                                                                            "count": 36,
                                                                                            "filter": "truck_type",
                                                                                            "filter_label": "Truck Type",
                                                                                            "isChecked": false,
                                                                                            "label": item.truck_name,
                                                                                            "type": item.truck_name,
                                                                                            "value": item.truck_name
                                                                                        }],



                                                                                    },
                                                                                    from_search: true
                                                                                }
                                                                            })}> {/* zIndex:995 */}
                                                                        <div className="card-body">
                                                                            <span className="annotation">{item.link_annotation}</span>
                                                                            <h3 style={{ marginTop: "1%" }} className="card-title redirect"><b><u></u>{item.title}</b></h3>

                                                                            <p className="card-text redirect">{item.description}</p>

                                                                        </div>
                                                                    </div>
                                                }

                                                <hr />
                                            </span>

                                        )) :
                                            // <>
                                            // <div className="row">
                                            //     <span>Did you mean?</span>
                                            // </div>
                                            // </>



                                            null
                                        }
                                        <Pagination
                                            activePage={activePage}
                                            itemsCountPerPage={perpage}
                                            totalItemsCount={
                                                (uniqueModules.includes("Transporter Profile") && !uniqueModules.includes("Compare Now")) ?
                                                    originalData.length - 10
                                                    :
                                                    originalData.length
                                            }
                                            pageRangeDisplayed={3}
                                            onChange={e => handlePageChange(e)}
                                            itemClass="page-item"
                                            linkClass="page-link"
                                            hideDisabled
                                        // hideFirstLastPages
                                        // prevPageText="prev"
                                        // nextPageText="next"
                                        // firstPageText="first"
                                        // lastPageText="last"
                                        />


                                    </>
                                    :
                                    <>
                                        {/* <span>
                                    Hello World
                                </span><br /> */}
                                        {/* <span><b>Please search from above / Marketing content</b></span> */}
                                        <div id="suggestions" className="div-suggestions">
                                            <span style={{ fontSize: '16px' }}>Is the results relevant to your search?</span>
                                            <span>
                                                <button className="btn btn-sm btn-success yes-button" onClick={e => noResults(e)}>
                                                    Yes
                                                </button>
                                                <button className="btn btn-sm btn-secondary no-button" onClick={e => noResults(e)}>
                                                    No
                                                </button>
                                            </span><hr />
                                        </div>
                                        <span style={{ marginLeft: '13px' }}><b>Please search as shown in examples below:</b></span><br />
                                        {search_suggestion.map((item, index) => (
                                            <span key={index}>
                                                <div className="card" style={{ cursor: "pointer" }}> {/* zIndex: '995' */}
                                                    <div className="card-body">
                                                        <p onClick={e => searchSuggestions(e, item)} className="card-text redirect">{item}</p>
                                                    </div>
                                                </div>
                                                <hr />
                                            </span>
                                        ))}



                                    </>
                                }

                            </div>
                            <div className="col-sm-5">
                                {/* <br /> */}

                                {data.length > 0 ? data.map((item, index) => (
                                    <span key={index}>
                                        {/* {console.log(module_filter)} */}
                                        {module_filter[0].value === "Transporter Profile" && index === 0 && activePage === 1 ?
                                            <>
                                                <div key={index} className="card" style={{ cursor: "pointer", position: 'fixed', marginTop: '1%', border: "1px solid rgba(0, 0, 0, 0.125)", display: 'none' }}> {/* zIndex:995 */}
                                                    <div className="card-body">
                                                        {/* <span className="annotation">{item.link_annotation}</span> */}
                                                        {/* <span className="first-annotation"><b>List of transporters from {item.title}</b></span> */}

                                                        <span className="card-text">

                                                            <span className="annotation">Showing top {transporterData.length} transporters</span>

                                                            {transporterData.length > 0 ?
                                                                transporterData.map((item, index) => (
                                                                    <>
                                                                        <div key={index} className="card s-card-height" style={{ cursor: "pointer", border: "1px solid rgba(0, 0, 0, 0.125)", marginTop: '5px' }}>
                                                                            <div className="card-body">
                                                                                {window.innerWidth > 600 ?
                                                                                    <>
                                                                                        <div className="row">
                                                                                            <div className='col-sm-2'>
                                                                                                <img height='40' width='40' style={{ borderRadius: "1000px" }} alt="profile_logo " id="profile_logo_screen" src={getImageSrc(item.logo)} onError={e => imageFallBack(e)} className="profile-img" />
                                                                                                {/* <img height='40' width='40' style={{ borderRadius: "1000px" }} src="logo.png" alt="profile_logo " id="profile_logo_screen" src={getImageSrc(item.logo)} onError={e => imageFallBack(e)} className="profile-img" /> */}
                                                                                            </div>
                                                                                            <div className='col-sm-6'>
                                                                                                {/* <span className="redirect" onClick={e => window.open(`https://company.lorri.in/tpmp/${encryptor(item.transporter_id, true)}`, "_blank", "noopener noreferrer")}>{Uppercase(item.title)}</span> */}
                                                                                                <ProfileModal
                                                                                                    // transporter_list={item.transporter_list}
                                                                                                    transporter_id={item.transporter_id}
                                                                                                    transporter_name={item.title}
                                                                                                    screenName={'Search Results'}
                                                                                                    moduleName={'LoRRI Search'}
                                                                                                    className="redirect"
                                                                                                // buttonClass={`${classes['own-modal-style']} btn-link`}
                                                                                                />
                                                                                            </div>
                                                                                            <div className='col-sm-4'>
                                                                                                <Rating
                                                                                                    style={{ width: '63%' }}
                                                                                                    initialRating={item.star_rating}
                                                                                                    readonly={true}
                                                                                                    emptySymbol={`fa fa-star ${classes['star-1']}`}
                                                                                                    fullSymbol={`fa fa-star ${classes['star-1-selected']}`} />
                                                                                                <span>
                                                                                                    <span style={{ fontSize: "12px" }}><b>{item.star_rating ? parseFloat(item.star_rating).toFixed(2) : "-"}</b></span> / <span style={{ fontSize: "12px" }}>5</span></span>
                                                                                                {/* <span style={{ fontSize: "large" }}><b>{item.star_rating}</b></span> / <span>5</span></span> */}
                                                                                            </div>
                                                                                        </div>
                                                                                        <br />
                                                                                    </> :
                                                                                    <>
                                                                                        <div style={{ display: 'inline-flex' }}>
                                                                                            <span>
                                                                                                <img height='40' width='40' style={{ borderRadius: "1000px" }} alt="profile_logo " id="profile_logo_screen" src={getImageSrc(item.logo)} onError={e => imageFallBack(e)} className="profile-img" />
                                                                                            </span>
                                                                                            <span style={{ width: '80%' }}>
                                                                                                <ProfileModal
                                                                                                    transporter_id={item.transporter_id}
                                                                                                    transporter_name={item.transporter_name}
                                                                                                    screenName={'Search Results'}
                                                                                                    moduleName={'LoRRI Search'}
                                                                                                />
                                                                                            </span>
                                                                                            <span style={{ width: '27%' }}>
                                                                                                <Rating
                                                                                                    style={{ width: '100%' }}
                                                                                                    initialRating={item.overall_rating}
                                                                                                    readonly={true}
                                                                                                    emptySymbol={`fa fa-star ${classes['star-1']}`}
                                                                                                    fullSymbol={`fa fa-star ${classes['star-1-selected']}`}
                                                                                                />
                                                                                            </span>
                                                                                            <span>
                                                                                                <span style={{ fontSize: "large" }}><b>{item.overall_rating ? parseFloat(item.overall_rating).toFixed(2) : "-"}</b></span> / <span>5</span>
                                                                                            </span>
                                                                                        </div>
                                                                                    </>
                                                                                }

                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                ))
                                                                :
                                                                <span>
                                                                    <Loader show={loading} />
                                                                </span>
                                                            }
                                                        </span>
                                                    </div>
                                                </div>
                                                {/* <div className="card view-all-button-div">
                                                <button onClick={e => history.push({ pathname: "/DiscoverNow" })} className="view-all-button"><i style={{ float: 'left', marginTop: '1.5%' }} className="fas fa-arrow-right"></i><span>View All</span></button>
                                            </div> */}
                                            </>
                                            :
                                            index === 0 && item.module_name !== "Benchmark Now"
                                                // && transporterData.length > 0
                                                && activePage === 1
                                                && module_filter[0].value !== ""
                                                ?
                                                // bada wala card
                                                loading ?
                                                    <CardLoader />
                                                    :

                                                    <>
                                                        <div className="card" style={{ cursor: "pointer", border: "1px solid rgba(0, 0, 0, 0.125)" }}> {/* zIndex:995 */}
                                                            <div className="card-body">
                                                                <span className="first-annotation"><b>List of transporters from {item.title}</b></span>

                                                                <span className="card-text"><br />

                                                                    <span className="annotation">Showing {transporterData.length}/{transporterCount} transporters</span>

                                                                    {transporterData.length >= 1 ?
                                                                        transporterData.map((item, index) => (
                                                                            <>
                                                                                <div key={index} className="card s-card-height" style={{ cursor: "pointer", border: "1px solid rgba(0, 0, 0, 0.125)", marginTop: '5px' }}>
                                                                                    <div className="card-body">
                                                                                        {window.innerWidth > 600 ?
                                                                                            <>
                                                                                                <div className="row">
                                                                                                    <div className='col-sm-2'>
                                                                                                        <img height='40' width='40' style={{ borderRadius: "1000px" }} alt="profile_logo " id="profile_logo_screen" src={getImageSrc(item.logo)} onError={e => imageFallBack(e)} className="profile-img" />
                                                                                                        {/* <img height='40' width='40' style={{ borderRadius: "1000px" }} src="logo.png" alt="profile_logo " id="profile_logo_screen" src={getImageSrc(item.logo)} onError={e => imageFallBack(e)} className="profile-img" /> */}
                                                                                                    </div>
                                                                                                    <div className='col-sm-6'>
                                                                                                        {/* <span className="redirect" onClick={e => window.open(`https://company.lorri.in/tpmp/${encryptor(item.transporter_id, true)}`, "_blank", "noopener noreferrer")}>{Uppercase(item.transporter_name)}</span> */}
                                                                                                        <ProfileModal
                                                                                                            // transporter_list={item.transporter_list}
                                                                                                            transporter_id={item.transporter_id}
                                                                                                            transporter_name={item.transporter_name}
                                                                                                            screenName={'Search Results'}
                                                                                                            moduleName={'LoRRI Search'}
                                                                                                            className="redirect"
                                                                                                        // buttonClass={`${classes['own-modal-style']} btn-link`}
                                                                                                        />
                                                                                                    </div>
                                                                                                    <div className='col-sm-4'>
                                                                                                        <Rating
                                                                                                            style={{ width: '63%' }}
                                                                                                            initialRating={item.overall_rating}
                                                                                                            readonly={true}
                                                                                                            emptySymbol={`fa fa-star ${classes['star-1']}`}
                                                                                                            fullSymbol={`fa fa-star ${classes['star-1-selected']}`} />
                                                                                                        <span>
                                                                                                            <span style={{ fontSize: "12px" }}><b>{item.overall_rating ? parseFloat(item.overall_rating).toFixed(2) : "-"}</b></span> / <span style={{ fontSize: "12px" }}>5</span>
                                                                                                        </span>
                                                                                                    </div>
                                                                                                </div>
                                                                                                <br />
                                                                                            </> :
                                                                                            <>
                                                                                                <div style={{ display: 'inline-flex' }}>
                                                                                                    <span>
                                                                                                        <img height='40' width='40' style={{ borderRadius: "1000px" }} alt="profile_logo " id="profile_logo_screen" src={getImageSrc(item.logo)} onError={e => imageFallBack(e)} className="profile-img" />
                                                                                                    </span>
                                                                                                    <span style={{ width: '80%' }}>
                                                                                                        <ProfileModal
                                                                                                            transporter_id={item.transporter_id}
                                                                                                            transporter_name={item.transporter_name}
                                                                                                            screenName={'Search Results'}
                                                                                                            moduleName={'LoRRI Search'}
                                                                                                        />
                                                                                                    </span>
                                                                                                    <span style={{ width: '27%' }}>
                                                                                                        <Rating
                                                                                                            style={{ width: '100%' }}
                                                                                                            initialRating={item.overall_rating}
                                                                                                            readonly={true}
                                                                                                            emptySymbol={`fa fa-star ${classes['star-1']}`}
                                                                                                            fullSymbol={`fa fa-star ${classes['star-1-selected']}`}
                                                                                                        />
                                                                                                    </span>
                                                                                                    <span>
                                                                                                        <span style={{ fontSize: "large" }}><b>{item.overall_rating ? parseFloat(item.overall_rating).toFixed(2) : "-"}</b></span> / <span>5</span>
                                                                                                    </span>
                                                                                                </div>
                                                                                            </>
                                                                                        }
                                                                                    </div>
                                                                                </div>
                                                                            </>
                                                                        ))
                                                                        :
                                                                        <>
                                                                            <br />
                                                                            <span style={{ textAlign: "center" }}>
                                                                                Sorry we could not find lsps catering to your need!
                                                                            </span>
                                                                        </>

                                                                    }
                                                                </span><br />
                                                                {/* <h3 style={{ marginTop: "1%" }} className="card-title"><b><u></u>{item.title}</b></h3> */}

                                                                {/* Bug in item.description */}
                                                                {/* <span className="card-text redirect"
                                                        onClick={e => history.push(
                                                            {
                                                                pathname: `/${item.module_name === "Location Dashboard" ? "locationdashboard" : item.module_name === "Benchmark Now" ? "BenchmarkNow" : item.module_name}`,
                                                                state: {
                                                                    data: {
                                                                        "lat": parseFloat(item.origin_lat ? item.origin_lat : 0),
                                                                        "lon": parseFloat(item.origin_lon ? item.origin_lon : 0),
                                                                        "location": item.origin ? item.origin : "",
                                                                        "district": item.origin_district ? item.origin_district : "",
                                                                        "state": item.origin_state ? item.origin_state : "",
                                                                        "origin": {
                                                                            "location_name": `${item.origin} , ${item.origin_district}, ${item.origin_state}`,
                                                                            "location": {
                                                                                lon: parseFloat(item.origin_lon ? item.origin_lon : 0),
                                                                                lat: parseFloat(item.origin_lat ? item.origin_lat : 0),
                                                                                'label': `${item.origin} , ${item.origin_district}, ${item.origin_state}`
                                                                            }
                                                                        },
                                                                        "inputOrigin": `${item.origin} , ${item.origin_district}, ${item.origin_state}`,
                                                                        "destination": {
                                                                            "location_name": `${item.destination}, ${item.destination_district}, ${item.destination_state}`,
                                                                            "location": {
                                                                                lon: parseFloat(item.destination_lon ? item.destination_lon : 0),
                                                                                lat: parseFloat(item.destination_lat ? item.destination_lat : 0),
                                                                                'label': `${item.destination}, ${item.destination_district}, ${item.destination_state}`
                                                                            }
                                                                        },

                                                                        "inputDestination": `${item.destination}, ${item.destination_district}, ${item.destination_state}`,
                                                                        "truck_type": item.truck_name,
                                                                        "destination_name": item.destination,
                                                                        "destination_district": item.destination_district,
                                                                        "destination_lat": item.destination_lat,
                                                                        "destination_lon": item.destination_lon,
                                                                        "destination_score": item.destination_score,
                                                                        "destination_state": item.destination_state,

                                                                        "origin_name": item.origin,
                                                                        "origin_district": item.origin_district,
                                                                        "origin_lat": item.origin_lat,
                                                                        "origin_lon": item.origin_lon,
                                                                        "origin_score": item.origin_score,
                                                                        "origin_state": item.origin_state,
                                                                        "filter_discovernow": [{
                                                                            "count": 36,
                                                                            "filter": "truck_type",
                                                                            "filter_label": "Truck Type",
                                                                            "isChecked": false,
                                                                            "label": item.truck_name,
                                                                            "type": item.truck_name,
                                                                            "value": item.truck_name
                                                                        }],



                                                                    },
                                                                    from_search: true
                                                                }
                                                            })}
                                                    >{item.description}</span> */}

                                                            </div>
                                                        </div>
                                                    </>
                                                : null

                                        }
                                        {/* <hr /> */}
                                    </span>
                                )) :
                                    null
                                }
                                {/* {data.length > 0 && data[0].module_name === "Transporter Profile" ?
                            rightElement(data) :
                            marketingElement(data)
                        } */}

                                {/* <Slide delay={50} mountOnEnter={data} duration={3000} top>
                            {marketingElement(data)}

                        </Slide> */}
                                {/* <Reveal effect="fadeInUp">
                            {marketingElement(data)}

                        </Reveal> */}
                            </div>
                        </div >
                    </div >
                </div>
            </div>
        </div >
    )
}

export default Searchresults
